import { render, staticRenderFns } from "./FormConfigPage.vue?vue&type=template&id=cc2ff9bc&"
import script from "./FormConfigPage.vue?vue&type=script&lang=js&"
export * from "./FormConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigPage.vue?vue&type=style&index=0&id=cc2ff9bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports